module.exports = __webpack_public_path__ + "static/media/mock-culbot1.b14aff85.png";